export const nrlScoring = [
  { name: "Try", type: 38, value: 4 },
  { name: "Conversion Successful", type: 1, value: 2 },
  { name: "Conversion Unsuccessful", type: 2, value: 0 },
  { name: "Penalty Goal Successful", type: 67, value: 2 },
  { name: "Penalty Goal Unsuccessful", type: 68, value: 0 },
  { name: "Field Goal Successful", type: 69, value: 1 },
  { name: "Field Goal Unsuccessful", type: 70, value: 0 },
  { name: "Try Under Posts", type: 102, value: 5 },
  { name: "Penalty Try", type: 99, value: 4 }, // Sent as 38 to STATS
];

export const gamePeriods = [
  { name: "First Half", type: 1 },
  { name: "Second Half", type: 2 },
  { name: "Extra Time", type: 3 },
];

export const eliteGameStates = [
  { name: "First Half", type: 3 },
  { name: "Half Time", type: 4 },
  { name: "Second Half", type: 5 },
  { name: "Extra Time", type: 6 },
  { name: "Final", type: 8 },
];

export const finalRounds = {
  1: [{ type: "Final", number: 1, label: "Grand Final" }],
  2: [
    { type: "Final", number: 1, label: "Semi Finals" },
    { type: "Final", number: 2, label: "Grand Final" },
  ],
  3: [
    { type: "Final", number: 1, label: "Semi Finals" },
    { type: "Final", number: 2, label: "Preliminary Final" },
    { type: "Final", number: 3, label: "Grand Final" },
  ],
  4: [
    { type: "Final", number: 1, label: "Elimination Finals" },
    { type: "Final", number: 2, label: "Semi Finals" },
    { type: "Final", number: 3, label: "Preliminary Final" },
    { type: "Final", number: 4, label: "Grand Final" },
  ],
};

export const orgtree = {
  1: {
    name: "Super Admin",
    dependencies: {
      1: [],
    },
    type: 1,
  },
  2: {
    name: "State Admin",
    dependencies: {
      1: ["states"],
      2: ["states"],
    },
    type: 2,
  },
  3: {
    name: "Region Admin",
    dependencies: {
      1: ["states", "regions"],
      2: ["regions"],
      3: ["regions"],
    },
    type: 3,
  },
  4: {
    name: "Association Admin",
    dependencies: {
      1: ["states", "regions", "associations"],
      2: ["regions", "associations"],
      3: ["associations"],
      4: ["associations"],
    },
    type: 4,
  },
  5: {
    name: "Club Admin",
    dependencies: {
      1: ["states", "regions", "associations", "clubs"],
      2: ["regions", "associations", "clubs"],
      3: ["associations", "clubs"],
      4: ["clubs"],
      5: ["clubs"],
    },
    type: 5,
  },
  6: {
    name: "Team Admin",
    dependencies: {
      1: ["states", "regions", "associations", "clubs", "teams"],
      2: ["regions", "associations", "clubs", "teams"],
      3: ["associations", "clubs", "teams"],
      4: ["clubs", "teams"],
      5: ["teams"],
      6: ["teams"],
    },
    type: 6,
  },
  50: {
    name: "Gameday Admin",
    dependencies: {
      1: ["states", "regions", "associations"],
      2: ["regions", "associations"],
      3: ["associations"],
      4: ["associations"],
    },
    type: 50,
  },
  51: {
    name: "Elite Gameday Admin",
    dependencies: {
      1: ["states", "regions", "associations"],
      2: ["regions", "associations"],
      3: ["associations"],
      4: ["associations"],
    },
    type: 51,
  },
  98: {
    name: "Game Dev Region Admin",
    dependencies: {
      1: ["game-dev-regions"],
      98: ["game-dev-regions"],
    },
    type: 98,
  },
  99: {
    name: "Program Admin",
    dependencies: {
      1: ["game-dev-regions"],
      98: ["game-dev-regions"],
    },
    type: 99,
  },
  101: {
    name: "Elite Team Admin",
    dependencies: {
      1: ["states", "regions", "associations", "clubs", "teams"],
      2: ["regions", "associations", "clubs", "teams"],
      3: ["associations", "clubs", "teams"],
      4: ["clubs", "teams"],
      5: ["teams"],
      6: ["teams"],
    },
    type: 101,
  },
  102: {
    name: "Elite Partner",
    dependencies: {
      1: ["states", "regions", "associations"],
      2: ["regions", "associations"],
      3: ["associations"],
      4: ["associations"],
    },
    type: 102,
  },
  418: {
    name: "Developer",
    dependencies: {},
    type: 418,
  },
};
